import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useCookieConsent } from "@/components/CookieBanner";

// REMINDER: scripts only inject when (a) admin has set the ID in Settings, AND (b) the user has accepted analytics cookies.
export default function AnalyticsInjector() {
  const { consent } = useCookieConsent();
  const [ids, setIds] = useState({ ga4: "", gtm: "", hotjar: "" });

  useEffect(() => {
    api.get("/settings/public").then((r) => {
      setIds({
        ga4: r.data?.ga4_measurement_id || "",
        gtm: r.data?.gtm_container_id || "",
        hotjar: r.data?.hotjar_site_id || "",
      });
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!consent?.analytics) return;

    // GA4
    if (ids.ga4 && !document.getElementById("ga4-script")) {
      const s = document.createElement("script");
      s.id = "ga4-script";
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${ids.ga4}`;
      document.head.appendChild(s);
      const inline = document.createElement("script");
      inline.id = "ga4-inline";
      inline.text = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${ids.ga4}', { anonymize_ip: true });`;
      document.head.appendChild(inline);
    }

    // GTM
    if (ids.gtm && !document.getElementById("gtm-script")) {
      const s = document.createElement("script");
      s.id = "gtm-script";
      s.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${ids.gtm}');`;
      document.head.appendChild(s);
      // noscript fallback iframe
      if (!document.getElementById("gtm-noscript")) {
        const ns = document.createElement("noscript");
        ns.id = "gtm-noscript";
        ns.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${ids.gtm}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
        document.body.insertBefore(ns, document.body.firstChild);
      }
    }

    // Hotjar
    if (ids.hotjar && !document.getElementById("hotjar-script")) {
      const s = document.createElement("script");
      s.id = "hotjar-script";
      s.text = `(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:${ids.hotjar},hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
      document.head.appendChild(s);
    }
  }, [consent, ids]);

  return null;
}
